const initialState = {
  list: [],
  selected: null,
  loading: false,
  error: null
}

const cmeReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CME_LOADING":
      return { ...state, loading: true, error: null }
    case "GET_ALL_CME": {
      const payload = action.data
      const list =
        (Array.isArray(payload?.data?.items) && payload.data.items) ||
        (Array.isArray(payload?.data?.data) && payload.data.data) ||
        (Array.isArray(payload?.data) && payload.data) ||
        (Array.isArray(payload?.items) && payload.items) ||
        (Array.isArray(payload) && payload) ||
        []
      return { ...state, list, loading: false, error: null }
    }
    case "GET_CME_BY_ID":
      return { ...state, selected: action.data?.data || action.data || null, loading: false }
    case "CME_ERROR":
      return { ...state, error: action.payload, loading: false }
    default:
      return state
  }
}

export default cmeReducer
